import { IconType } from "react-icons";
import { BiLogoFacebook } from "react-icons/bi";
import { BsInstagram, BsTwitterX, BsWhatsapp, BsYoutube } from "react-icons/bs";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

export type SocialIconsKey =
  | "instagram"
  | "facebook"
  | "twitter"
  | "whatsapp"
  | "youtube"
  | "linkedin"
  | "mail";

export const socialIconsMap: { [key in SocialIconsKey]: IconType } = {
  instagram: BsInstagram,
  facebook: FaFacebookF,
  twitter: BsTwitterX,
  whatsapp: BsWhatsapp,
  youtube: BsYoutube,
  linkedin: FaLinkedinIn,
  mail: FiMail,
};

// Encode query values so titles/URLs containing &, #, ? etc. don't break the share link
const enc = (value?: string) => encodeURIComponent(value ?? "");

export const socialShareOptions = [
  {
    name: "Facebook",
    icon: socialIconsMap["facebook"],
    generateLink: (url: string) => `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
    color: "#1d77f2",
  },
  {
    name: "Twitter",
    icon: socialIconsMap["twitter"],
    generateLink: (url: string, title: string) =>
      `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`,
    color: "#000000",
  },
  {
    name: "Whatsapp",
    icon: socialIconsMap["whatsapp"],
    generateLink: (url: string, title: string) =>
      `https://api.whatsapp.com/send?text=${enc(`${title ?? ""} ${url}`)}`,
    color: "#26d366",
  },
  {
    name: "LinkedIn",
    icon: socialIconsMap["linkedin"],
    generateLink: (url: string) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`,
    color: "#1789d1",
  },
  {
    name: "Email",
    icon: socialIconsMap["mail"],
    generateLink: (url: string, title: string) =>
      `mailto:?subject=${enc(`Check out this article: ${title ?? ""}`)}&body=${enc(
        `Here is a link to an article I thought you might be interested in: ${url}`,
      )}`,
    color: "",
  },
];

export const channels = {
  ml: {
    telegram: "https://t.me/DbiDaily",
    whatsapp: "https://www.whatsapp.com/channel/0029VaSeRWJJf05YLVwC1e05",
    instagram: "https://www.instagram.com/deshabhimanilive/",
  },
  en: {
    telegram: "https://t.me/deshabhimaniglobal",
    whatsapp: "https://whatsapp.com/channel/0029VbAgt9jEFeXre6kOg90X",
    instagram: "https://www.instagram.com/deshabhimanilive/",
  },
};
